import React from 'react';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { text as textColors } from '../../utils/darkModeAdapter';
import Layout from '../../components/Layout';

function Terms() {
  const theme = useTheme();
  return (
    <Layout>
      <Container maxWidth="md" sx={{ pt: 8, pb: 3 }}>
        <Paper elevation={1} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3, color: textColors(theme).primary, fontWeight: 'bold', textAlign: 'center' }}>
            利用規約
          </Typography>
          
          <Typography variant="h6" sx={{ mb: 2, color: textColors(theme).secondary, textAlign: 'center' }}>
            AI人事 利用規約 2025.06.26
          </Typography>

          <Divider sx={{ mb: 3 }} />
          
          <Box sx={{ '& > *': { mb: 3 } }}>
            
            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第1条（目的・適用）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                本利用規約（以下「本規約」といいます。）は、当社が提供する中小企業向けAI人事SaaS「AI人事」（以下「本サービス」といいます。）の利用条件および当社とユーザーとの間の権利義務関係を定めるものです。本サービスをご利用になる法人または、個人ユーザー（以下「ユーザー」といいます。）は、本規約に同意したうえで本サービスを利用するものとします。なお、当社が当社ウェブサイト上で掲載する本サービスに関する個別ルールや追加規定がある場合、それらは本規約の一部を構成し、本規約と矛盾する場合は個別規定が優先されるものとします。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第2条（定義）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                本規約において使用する主要な用語の定義は以下のとおりとします。
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (1) 「当社」とは、本サービスを提供する運営会社株式会社綜合企画をいいます。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (2) 「ユーザー」とは、本サービスの利用申し込みを行い、当社が承認した法人または団体、個人をいいます。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (3) 「本サービス」とは、当社が提供する「AI人事」と称する人事支援クラウドサービスの総称をいいます（名称や内容が変更された場合は変更後のサービスを含みます）。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (4) 「利用契約」とは、本規約に基づき当社とユーザーとの間で成立する、本サービスの利用に関する契約をいいます。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (5) 「登録情報」とは、ユーザーが本サービス利用の申し込み時に当社に提供する情報をいいます。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (6) 「候補者情報」とは、ユーザーが本サービス上で管理・利用する面接候補者等の個人情報（氏名、連絡先、学歴職歴等）をいいます。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (7) 「知的財産権」とは、著作権、商標、特許権等の知的財産に関する一切の権利をいいます。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  (8) 「外部AIサービス」とは、本サービスの一部機能において利用される、当社以外の第三者が提供するAIサービス（OpenAI社の提供するAPI等）をいいます。
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第3条（利用登録と承認）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約に同意の上、当社所定の情報（会社名、所在地、担当者氏名・連絡先等）を当社所定の方法（オンライン申込フォーム等）で提供し、利用申請を行うものとします。当社は当社基準に従い申請内容を審査し、承認する場合にはその旨を通知します。当社が承認の通知を行った時点で利用契約が成立し、ユーザーは本サービスを利用できるものとします。なお、当社は、登録希望者が以下の各号のいずれかに該当すると判断した場合、利用申請を承認しないことがあります。
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • (1) 登録情報に虚偽、誤記又は記入漏れがあった場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • (2) 過去に本サービスの利用契約の解除等の措置を受けたことがある場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • (3) 未成年者等で法定代理人の同意を得ていない場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • (4) 反社会的勢力等（暴力団、暴力団員、反社会的集団の構成員等）である場合、またはそれらへの資金提供や関与が認められる場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • (5) その他当社が申請を不適切と判断する場合
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第4条（本サービスの内容）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                本サービスは、人工知能を活用して中小企業の人事業務（採用計画の作成、求人媒体の選定、求人票の自動作成、面接サポート、マッチング分析、チャットによる問い合わせ対応支援、質問項目の自動生成等）を支援するクラウドサービスです。ユーザーは本サービスを通じて、自社の採用に関する各種データの登録・管理および分析、外部AIサービスを利用したコンテンツの生成等を行うことができます。なお、当社は本サービスの内容をユーザーへの事前通知なく変更・追加または一時的な中断を行うことがあります。本サービスの提供終了または大幅な変更を行う場合には、可能な限り事前に当社ウェブサイト上で告知します。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第5条（利用料金と支払）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                本サービスは有料サービスです。ユーザーは、本サービス利用の対価として、申込時に同意したプランに応じた利用料金を、当社指定の方法（銀行振込、クレジットカード等）で支払うものとします。利用料金には別途消費税等が加算されます。ユーザーが支払期日を過ぎてもなお利用料金を支払わない場合、年14.6%の割合による遅延損害金を支払うものとします。当社の故意または重大な過失による場合を除き、契約期間中にユーザーが途中解約をした場合でも既払いの利用料金の返金は行いません。また、契約期間内に発生済みの料金支払債務については、サービス提供の停止後もユーザーはその履行責任を負うものとします。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第6条（契約期間と解約）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                本サービスの最低利用期間は別途契約書等で定めるとおりとします。契約期間満了の一定期間前までにユーザーまたは当社から書面による解約の意思表示がない限り、利用契約は同一条件で自動更新されるものとします。ユーザーが契約期間途中で本サービスの利用を解約する場合、前条に定めるとおり既払い料金の返金は原則いたしません。また、ユーザーが本規約に違反した場合、当社は何らの催告を要せず利用契約を解除し、本サービスの利用を停止することができます。この場合、当社は当該違反によりユーザーまたは第三者に生じた損害について一切責任を負いません。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第7条（アカウントの管理）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                当社は、ユーザーごとに本サービスのログインIDおよびパスワードその他のアカウント情報を発行する場合があります。ユーザーは自己の責任においてアカウント情報を厳重に管理・保管し、これを第三者に利用させたり、貸与・譲渡・名義変更・売買してはなりません。アカウント情報の漏えい、不正使用により生じた損害について当社は責任を負いません。ユーザーは、アカウント情報が第三者に不正に使用されていることが判明した場合、直ちに当社に通知するとともに、当社の指示に従うものとします。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第8条（外部AIサービスの利用とデータの取扱い）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                ユーザーは、本サービスの一機能として提供されるチャット機能や質問項目自動生成機能等を利用する際、当社が提携する外部AIサービスに対して入力内容が送信され処理される場合があることを予め承諾します。当社は、これら外部AIサービス提供者との間で適切な契約を締結し、ユーザーから送信される情報が機械学習の目的に利用されないよう努めます。ユーザーは、外部AIサービスの利用にあたり、当該サービスの提供元が定める利用規約やポリシーを遵守するものとし、違法または不適切な情報を入力しないものとします。特に、本サービスに入力・送信する情報について、以下の内容を含めないようユーザーは十分注意してください。
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 公序良俗に反する情報や犯罪行為に関連する情報
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 第三者の権利（知的財産権、プライバシー、名誉等）を侵害する情報
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 第三者（応募候補者など）に関するセンシティブな個人情報（機微情報）や秘密情報（ユーザーまたは第三者の営業秘密など）
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 法令（労働関連法規、個人情報保護法等）に違反する情報
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                当社は、ユーザーが本サービスを通じて送受信したテキストや生成されたコンテンツ（求人票テンプレートや面接質問など）を当社のデータベースに保存し、本サービスの改善、不正利用の防止・分析等のために個人が特定できない形で統計的に利用することがあります。ユーザーは、本サービスから得られた生成コンテンツを自己および自社の業務範囲内で期間・地域の制限なく無償で利用できるものとします。ただし、当社または外部AI提供元は当該コンテンツが第三者の知的財産権を侵害していないことを保証するものではなく、必要な権利処理はユーザー自身の責任と費用負担で行うものとします。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第9条（禁止行為）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                ユーザーは、本サービスの利用に際し、以下の各号に該当する行為（またはそのおそれがある行為）を自ら行ってはならず、また第三者をして行わせてはなりません。
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  1. 当社、他のユーザーまたは第三者の知的財産権、プライバシー権、名誉権その他の権利または利益を侵害する行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  2. 法令または公序良俗に違反する行為、犯罪行為に関連する行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  3. 本サービスのシステムやネットワークに不正にアクセスしたり、過度な負荷をかける行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  4. 本サービス上で入手した他のユーザーの情報を無断で収集、利用または第三者へ提供する行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  5. 虚偽の情報を登録または発信する行為、第三者になりすます行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  6. 有害なプログラム・スクリプト等を送信または書き込む行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  7. 本サービスをリバースエンジニアリング、解析、複製等する行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  8. 本サービスの運営を妨害する行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  9. 労働基準法、職業安定法、個人情報保護法その他の関連法令またはユーザーが所属する業界団体の内部規則に違反する行為。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  10. その他、当社が不適切と判断する行為。
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                ユーザーが上記のいずれかに違反したと当社が判断した場合、当社は事前の通知なくユーザーによる本サービスの利用停止・契約解除等の措置を講じることができるものとします。その際当社はユーザーに生じうる損害について一切責任を負いません。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                第10条（当社によるデータアクセスと秘密保持）
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                当社は、本サービスの運用・保守およびサポート提供に必要な範囲で、ユーザーの本サービス上のデータや利用履歴にアクセスする場合があります（例：障害対応やユーザーからの問い合わせ対応時における確認作業等）。当社および当社従業員は、業務上知り得たユーザーの秘密情報（登録情報、候補者情報、本サービスの利用によって取得した一切の情報を含みます）について、法令に基づく場合を除き、第三者に開示・漏洩しないものとします。
              </Typography>
            </Box>

          </Box>
        </Paper>
      </Container>
    </Layout>
  );
}

export default Terms; 